export const ProgressColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;
export type ProgressColor = (typeof ProgressColor)[keyof typeof ProgressColor];
